module.exports = __webpack_public_path__ + "static/media/videoActive.5341a5fa.png";